<div class="m-4 px-6 pb-8 bg-white rounded-lg flex flex-col gap-6">
  <div class="flex flex-col gap-y-7 w-full">
    <div class="lg:px-8 px-0 bg-white flex flex-col gap-4">
      <div
        class="p-4 text-general-title text-white bg-[--brand-azul-primario] flex flex-col gap-4 w-full rounded-lg"
      ></div>
      <div class="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        <div class="col-span-2 flex justify-center items-center">
          {{ 'general-pages.contracts.generatePdf' | translate }}
        </div>
        <button
          class="button-general text-center !w-auto h-12.75 mt-2"
          matButton="filled"
          (click)="openQuotationPDFDialog()"
        >
          {{ 'general-pages.contracts.contract' | translate }}
        </button>
      </div>
    </div>

    <div class="lg:px-8 px-0 bg-white flex flex-col gap-4">
      <div
        class="p-4 text-general-subtitle text-white bg-[--brand-azul-primario] flex flex-col gap-4 w-full rounded-lg"
      ></div>
      <div class="flex flex-col justify-center items-center gap-4">
        <div class="flex gap-4 items-center">
          <!-- <button
            class="bg-primary! rounded-md text-white! text-base! text-center px-4 !w-auto h-12.75"
            mat-menu-item
          >
            Enviar Recordatorio de firma
          </button> -->

          @if (this.mifielStartData!.documentos[0].mifieL_CONTRACT_ID !== '') {
            <div class="w-full flex flex-col gap-4 items-center justify-center">
              <div class="flex justify-center items-center">
                {{ 'general-pages.contracts.configuredToSign' | translate }}
              </div>
              <div class="flex justify-center items-center">
                {{ 'general-pages.contracts.checkStatus' | translate }}
              </div>
              <button
                class="button-general text-center !w-auto h-12.75 mt-6"
                matButton="filled"
                (click)="checkStatusMifiel()"
              >
                {{ 'general-pages.contracts.viewStatus' | translate }}
              </button>

              <button
                class="button-general text-center w-auto! h-12.75 mt-6"
                matButton="filled"
                (click)="cancelContract()"
              >
                {{ 'general-pages.contracts.cancelSign' | translate }}
              </button>
            </div>
          } @else {
            <div class="w-full flex gap-4 items-center flex-col">
              <div class="col-span-full flex justify-center items-center">
                {{ 'general-pages.contracts.signElectronically' | translate }}
              </div>

              <div class="flex gap-4 items-center">
                <div class="mt-5.25">
                  <app-input-general-select
                    [formControlGeneral]="representantes"
                    [inputSelect]="{ value: 'id', description: 'nombrE_COMPLETO' }"
                    class="col-span-full"
                    [label]="'general-pages.contracts.representatives' | translate"
                    [placeholder]="'general-pages.contracts.representatives' | translate"
                    [arrayData]="mifielStartData!.representantes"
                  ></app-input-general-select>
                </div>

                <button
                  class="button-general text-center w-auto! h-12.75 mt-6"
                  matButton="filled"
                  (click)="signContract()"
                  [disabled]="representantes.invalid"
                >
                  {{ 'general-pages.contracts.sign' | translate }}
                </button>
              </div>
            </div>
          }
        </div>

        @if (this.dataSource.data.length) {
          <app-table-general-simple
            class="col-span-full"
            [dataSource]="dataSource"
            [headers]="headers"
            [buttonEvent]="false"
          ></app-table-general-simple>
        }
      </div>
    </div>
  </div>
</div>

<app-load-general [load]="loadService"></app-load-general>
